import AtlassianIcon from "@/assets/images/atlassian-icon.png";
import AWSIcon from "@/assets/images/aws-icon.png";
import GithubIcon from "@/assets/images/github-icon.png";
import GoogleIcon from "@/assets/images/google-icon.png";
import MicrosoftIcon from "@/assets/images/microsoft-icon.png";
import SlackIcon from "@/assets/images/slack-icon.png";
import Button from "@/components/button/Button.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {CTABanner} from "@/marketingPages/components/ctabanner/CTABanner.tsx";

import styles from "./AllServicesBanner.module.scss";

export const AllServicesBanner = () => {
  return (
    <CTABanner
      left={
        <div className={styles.allServicesBannerIcons}>
          <div className={styles.googleIcon}>
            <img src={GoogleIcon} alt="Google" title="Google" />
          </div>
          <div>
            <img src={AtlassianIcon} alt="Atlassian" title="Atlassian" />
          </div>
          <div>
            <img src={AWSIcon} alt="AWS" title="AWS" />
          </div>
        </div>
      }
      middleText="Get notified when a cloud service or third-party provider you depend on is having an incident."
      middleButton={
        <Button
          variant="marketingSecondary"
          size="marketingLarge"
          as="a"
          href={`${URL_ORIGINAL_WEBSITE}/accounts/register`}
        >
          Get Started
        </Button>
      }
      right={
        <div className={styles.allServicesBannerIcons}>
          <div className={styles.microsoftIcon}>
            <img src={MicrosoftIcon} alt="Microsoft" title="Microsoft" />
          </div>
          <div className={styles.githubIcon}>
            <img src={GithubIcon} alt="Github" title="Github" />
          </div>
          <div>
            <img src={SlackIcon} alt="Slack" title="Slack" />
          </div>
        </div>
      }
    />
  );
};
